import React from 'react';
import { TextInput } from '@abyss/web/ui/TextInput';
import { usePropsContext } from 'src/hooks/usePropsContext';
import { styled } from '@abyss/web/tools/styled';

const StyledTextInput = styled(TextInput, {
  '&.abyss-text-input': {
    backgroundColor: '$white',
  },
});

export const TaxID = () => {
  const { onBlur } = usePropsContext();

  return (
    <StyledTextInput
      data-testid="taxid"
      label="Tax ID number"
      model="taxId"
      maxLength={9}
      minLength={9}
      validators={{
        required: 'Please enter a valid 9-digit Tax ID',
        minLength: {
          value: 9,
          message: 'Please enter a valid 9-digit Tax ID',
        },
      }}
      mask="numeric"
      maskConfig={{
        allowLeadingZeros: true,
      }}
      formatter={value => {
        return value.replace(/[^0-9]/g, '');
      }}
      width="236px"
      onBlur={() => onBlur('Tax ID number')}
    />
  );
};
